import './InvoicePreview.scss';
import { type InvoiceDetails } from '../../interfaces';
import { isNewZealandProvider, getProviderContactAddress } from 'utils/providerUtils';

export interface AURecipientSupplierDetailsProps {
    invoice: InvoiceDetails;
}

export const AURecipientSupplierDetails: React.FC<AURecipientSupplierDetailsProps> = ( { invoice } ) => {
    const contactAddress = getProviderContactAddress(invoice);
    const isNZProvider = isNewZealandProvider(invoice);
    
    return ( 
    <table className='invoice_recipient_supplier_details'>
        <thead>
            <tr>
                <th>From - Recipient:</th>
                <th>To - Supplier:</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                {
                    isNZProvider ?
                    (
                        <td>
                            <p>TELUS Health NZ Limited</p>
                            <p>PO BOX 38864</p>
                            <p>Howick</p>
                            <p>Auckland 2145</p>
                            <p className="well_spaced">NEW ZEALAND</p>
                        </td>
                    ) :
                    (
                        <td>
                            <p>TELUS Health (Australia) Pty Ltd Group of Companies</p>
                            <p>(TELUS Health (BG Australia) Pty Ltd,</p><p>TELUS Health (SMG Australia) Pty Ltd)</p>
                            <p>Lv. 25 303 Collins Street</p>
                            <p className="well_spaced">MELBOURNE VIC 3000</p>
                            <p>Aus_Accounts_Payable@telushealth.com</p>
                            <br />
                            <p className="business_number">ABN 45134449059</p>
                            <p className="business_number">ABN 61003536472</p>
                            <p className="business_number">ABN 62605939697</p>
                        </td>
                    )
                }
                <td>
                    <p>{invoice.provider.vendor?.name || `${invoice.provider.firstName} ${invoice.provider.lastName}`}</p>
                    <p className="well_spaced">{contactAddress.addressLine1}</p>
                    {!!contactAddress.addressLine2 && <p>{contactAddress.addressLine2}</p>}

                    <p className="well_spaced">{contactAddress.city || ''}&nbsp;{contactAddress.provinceAbbreviation}&nbsp;{contactAddress.zIP_Postal} </p>

                    <p>{invoice.provider.vendor?.email || invoice.provider.emailAddress}</p>
                    <br />
                    <p className="business_number">{isNZProvider? 'NZ BN' : 'ABN'} {invoice.provider.businessNumber}</p>
                </td>
            </tr>
        </tbody>
    </table>
    );
};
